import { createRouter, createWebHistory } from 'vue-router'
import { ref } from 'vue'
import QuizView from './quiz/QuizView.vue'
import SavedResults from './components/custom/SavedResults.vue'
import EndPageGeneral from './endPages/EndPageGeneral.vue'
import axiosInstance from './plugins/axios'
import FaqView from './faq/FaqView.vue'

const defaultLanguage = ref('')
const enabledLanguagesCodes = ref([])

// Lade Sprachkonfigurationen
const getLanguageConfig = async () => {
  const response = await axiosInstance.get('/config/langaugeSettings')
  defaultLanguage.value = response.data.dL
  enabledLanguagesCodes.value = response.data.eL
}

// Überprüfe, ob die Sprache aktiviert ist
const compareEnabledLanguages = async (lang: string) => {
  return enabledLanguagesCodes.value.includes(lang)
}

// Initialisierungsfunktion
const initializeRouter = async () => {
  await getLanguageConfig()

  const routes = [
    { path: '/', component: QuizView },
    { path: '/saved-results', component: SavedResults },
    {
      path: '/faq',
      name: 'Faq',
      component: FaqView,
      beforeEnter: async (to, from, next) => {
        const { useStyleStore } = await import('./store/styleStore')
        const styleStore = useStyleStore()

        if (!styleStore.isStylesLoaded) {
          await styleStore.loadStyles()
        }

        if (styleStore.styles.faqVisible?.value) {
          next()
        } else {
          next('/')
        }
      }
    },
    { path: '/results/:reportID', component: EndPageGeneral }
  ]

  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  router.beforeEach(async (to, from, next) => {
    if (!to.query.lang) {
      next({
        ...to,
        query: {
          ...to.query,
          lang: defaultLanguage.value
        }
      })
    } else {
      if (!(await compareEnabledLanguages(to.query.lang as string))) {
        next({
          ...to,
          query: {
            ...to.query,
            lang: defaultLanguage.value
          }
        })
      } else {
        next()
      }
    }
  })

  return router
}

export default initializeRouter
